var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredWatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DFE2EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0002,
    cy: 43.9988,
    r: 26.6316,
    fill: "white",
    stroke: "#00193C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4209 45.1571C32.4209 46.6776 32.7204 48.1833 33.3023 49.5881C33.8842 50.993 34.7371 52.2694 35.8123 53.3446C36.8875 54.4198 38.164 55.2727 39.5688 55.8546C40.9736 56.4365 42.4793 56.736 43.9998 56.736C45.5204 56.736 47.0261 56.4365 48.4309 55.8546C49.8357 55.2727 51.1122 54.4198 52.1874 53.3446C53.2626 52.2694 54.1155 50.993 54.6974 49.5881C55.2793 48.1833 55.5788 46.6776 55.5788 45.1571C55.5788 42.0861 54.3589 39.141 52.1874 36.9695C50.0159 34.798 47.0708 33.5781 43.9998 33.5781C40.9289 33.5781 37.9838 34.798 35.8123 36.9695C33.6408 39.141 32.4209 42.0861 32.4209 45.1571Z",
    stroke: "#00193C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33.5792V30.1055",
    stroke: "#00193C",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4737 30.1055L40.5264 30.1055",
    stroke: "#00193C",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40.5273V46.3168L47.4737 49.7905",
    stroke: "#00193C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4326 34.7231C53.0941 34.0843 54.1482 34.1027 54.787 34.7641C55.4258 35.4256 55.4074 36.4797 54.7459 37.1185L53.4449 38.3749L51.1316 35.9794L52.4326 34.7231Z",
    fill: "#0E5CF4",
    stroke: "#00193C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.124 34.7231C34.4625 34.0843 33.4084 34.1027 32.7696 34.7641C32.1308 35.4256 32.1492 36.4797 32.8107 37.1185L34.1117 38.3749L36.425 35.9794L35.124 34.7231Z",
    fill: "#0E5CF4",
    stroke: "#00193C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredWatch);
export default __webpack_public_path__ + "static/media/ic-colored-watch.b6cea0eb463a1c0030231edc09305f6a.svg";
export { ForwardRef as ReactComponent };